'use client';

import { useQuery } from '@tanstack/react-query';

import { InsuranceAssetType } from '@entities/investments';
import { IErrorResponse } from '@shared/api';

import {
  CONFIGURATIONS_CACHE_KEY,
  getInsuranceConfigurations,
  TInsuranceConfigurationsResponse,
} from '../api';

export const useGetConfigurations = (
  assetType: InsuranceAssetType = InsuranceAssetType.Gold,
  options?: { enabled?: boolean },
) => {
  return useQuery<TInsuranceConfigurationsResponse, IErrorResponse>({
    queryKey: [CONFIGURATIONS_CACHE_KEY, assetType],
    queryFn: () => getInsuranceConfigurations(assetType),
    enabled: options?.enabled ?? true,
    retry: false,
  });
};
